module.exports = __webpack_public_path__ + "static/media/m_y_55.4512bf1f.png";